export const initialModalState = {
    isAddBookingModalOpen: false,
    addBookingModalDate: null,
    isBookingSummaryOpen: false,
    bookingSummaryDays: [],
    isPromptAddAbsenceOpen: false,
    isAddAbsenceStepperOpen: false,
};
